// FilterField.tsx
import React from 'react';
import { Grid } from '@material-ui/core';
import { Controller, Control } from 'react-hook-form';
import Visible from 'src/components/Visibile';
import MultiSelectField from 'src/components/MultiSelectField';


interface FilterFieldProps {
  name: string;
  label: string;
  control: Control<any>;
  options: any[];
  isVisible?: boolean;
  isMultiple?: boolean;
  disabled?: boolean;
  formatMessage: (msg: any) => string;
  onChangeWrapper: (onChange: (val: any) => void) => (val: any) => void;
}

const FilterField: React.FC<FilterFieldProps> = ({
  name,
  label,
  control,
  options,
  isVisible = true,
  isMultiple = true,
  disabled = false,
  formatMessage,
  onChangeWrapper
}) => {
  if (!isVisible) return null;

  return (
    <Visible if={isVisible}>
      <Grid item xs={12} md={4} lg={3}>
        <Controller
          name={name}
          control={control}
          render={({ onChange, value }) => (
            <MultiSelectField
              label={label}
              onChange={onChangeWrapper(onChange)}
              options={options}
              value={value}
              disabled={disabled}
              isMultiple={isMultiple}
            />
          )}
        />
      </Grid>
    </Visible>
  );
};

export default FilterField;
